module.exports = __webpack_public_path__ + "img/message-black.51cbf34e.svg";